import { ComponentType, Parameter } from "@/queries/models/types";
import { ParametersObject } from "@/components/ModelParameters/utils";

export const processDefaultValue = (param: Parameter) => {
  if (param.component_type === ComponentType.GROUP) {
    return param.parameters?.reduce((acc: ParametersObject, nestedParam: Parameter) => {
      const processedValue = processDefaultValue(nestedParam);

      if (processedValue !== undefined) {
        acc[nestedParam.param_id] = processedValue;
      }

      return acc;
    }, {});
  }

  return param.default;
};
